import React, { useEffect } from "react";
import ChatbotEmbed from "./components/ChatbotEmbed";

function App() {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="flex items-center justify-between p-4 bg-gray-800 shadow-md">
        <div className="flex items-center space-x-2">
          <img src="https://db.aivacompany.com/download/noco/ppyqqo3332e6467/mzgf1rfvbp4g620/cdkisoiazk67qu4/Logo%20AIVA_MyPxZ.png" alt="AIVA Logo" className="h-12" />
          <h1 className="text-2xl font-bold">AIVA</h1>
        </div>
        <nav className="space-x-4">
          <a href="#inicio" className="hover:text-blue-400">Inicio</a>
          <a href="#servicios" className="hover:text-blue-400">Servicios</a>
          <a href="#testimonios" className="hover:text-blue-400">Testimonios</a>
          <a href="#contacto" className="hover:text-blue-400">Contacto</a>
        </nav>
      </header>

      <main className="mt-16 px-8">
        <section id="inicio" className="text-center py-20">
          <h2 className="text-4xl font-bold mb-4">Automatiza tu negocio con AIVA 🚀</h2>
          <p className="text-lg mb-6">Chatbots Inteligentes, Automatización de WhatsApp y Desarrollo de Aplicaciones.</p>
          <a href="#contacto" className="bg-blue-500 text-white px-6 py-3 rounded-full hover:bg-blue-600">Iniciar Chat en WhatsApp</a>
        </section>
      </main>

      <footer className="bg-gray-800 text-center py-4 text-gray-400">
        <p>&copy; 2025 AIVA. Todos los derechos reservados.</p>
      </footer>

      <ChatbotEmbed />
    </div>
  );
}

export default App;
